import { ProFormInstance } from '@ant-design/pro-form';
import constate from 'constate';
import { useImmer } from 'use-immer';
import { getParamFromUrl } from '@/infrastructure/history';
import { HprofFileStatusType } from '@/presentation/pages/memory/memory-detail/config';
import { IFilter } from '@/proto/metric';

export interface TdsFormContext {
  token: string;
  fieldsValue?: Record<string, any>;
  fieldsFilter?: IFilter[];
  compareFieldsValue?: Record<string, any>;
  compareFieldsFilter?: IFilter[];
  uuidFetch?: string;
  isCompare?: boolean;
  form?: ProFormInstance;
  hprofFileStatus?: (HprofFileStatusType|null)
}

function useForm() {
  const [value, setValue] = useImmer<TdsFormContext>({
    token: getParamFromUrl('token'),
    fieldsValue: {},
    fieldsFilter: [],
    compareFieldsValue: {},
    compareFieldsFilter: [],
    uuidFetch: undefined,
    isCompare: false,
    form: undefined,
  });


  return { formContext: value, updateFormContext: setValue };
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const useTdsForm = constate(useForm);

const [TdsFormProvider, useTdsFormContext] = useTdsForm;

export {
  useTdsForm,
  TdsFormProvider,
  useTdsFormContext,
};
